/*
 *
 * LanguageProvider reducer
 *
 */
import { fromJS } from "immutable";
import { CHANGE_LOCALE } from "./constants";
import { DEFAULT_LOCALE } from "../../i18n";
import moment from "moment"; // eslint-disable-line

export const initialState = fromJS({
  locale: DEFAULT_LOCALE,
});

function languageProviderReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LOCALE: {
      const currentLocale = state.get("locale").toLowerCase();
      const newLocale = action.locale.toLowerCase();
      moment.locale(newLocale);
      if (currentLocale !== newLocale) {
        return state.set("locale", newLocale);
      }
      return state;
    }
    default:
      return state;
  }
}

export default languageProviderReducer;
